import { useState } from "react";
import type { ReportDetail } from "../api";

/**
 * What the latest run could not settle from the conversations or the
 * numbers -- the report's own open questions and the metrics pre-pass's --
 * which is most of what is worth asking the customer next.
 */
export default function AskCard({ name, report }: { name: string; report: ReportDetail }) {
  const [copied, setCopied] = useState(false);
  const questions = [...report.report.open_questions, ...(report.report.platform?.open_questions ?? [])];
  if (questions.length === 0) return null;

  const copy = () => {
    const text = questions.map((q, i) => `${i + 1}. ${q}`).join("\n");
    void navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      })
      .catch(() => setCopied(false));
  };

  return (
    <section className="card ov-side" aria-labelledby="ov-ask">
      <div className="ov-side-head">
        <h3 id="ov-ask">Ask {name}</h3>
        <button className="tiny" onClick={copy}>
          {copied ? "Copied" : "Copy all"}
        </button>
      </div>
      <ol className="ov-ask">
        {questions.map((q, i) => (
          <li key={i}>{q}</li>
        ))}
      </ol>
      <span className="dim">Open questions from the {report.report_date} report</span>
    </section>
  );
}
